import { useTranslation } from "react-i18next";
import "./ContactForm.css";
import "../Stats/Stats.css"
import React, { useContext, useState } from "react";
import DimensionsContext from "../../../context/dimensions/dimensions";
import { useHttp } from "../../../hooks/useHttps";
import Snackbar from "@mui/material/Snackbar";

import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ContactForm() {
  const { t } = useTranslation();
  const { x } = useContext(DimensionsContext);
  const { request } = useHttp();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackMessage, setSnackMessage] = useState<string>();
  const [severity, setSeverity] = useState<AlertColor>();

  const [name, setName] = useState<string>();
  const [company, setCompany] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [telegram, setTelegram] = useState<string>();
  const [message, setMessage] = useState<string>();

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  const sendMessage = async () => {
    try {
      if (
        name === undefined ||
        company === undefined ||
        email === undefined ||
        message === undefined
      ) {
        setSeverity("error");
        setSnackMessage(
          "Failed to send inquiry: You need to fill in the required inputs"
        );
        setOpenSnackbar(true);
        return;
      }
      const data = await request("/api/inquiry", "POST", {
        name,
        company,
        email,
        telegram,
        message,
      });
      if (
        data.statusCode === 500 ||
        data.statusCode === 400 ||
        data.statusCode === 403
      ) {
        setSeverity("error");
        setSnackMessage("Failed to send inquiry: Internal server error");
        setOpenSnackbar(true);
        return;
      }
      setSnackMessage("Successfully sent inquiry");
      setSeverity("success");
      setOpenSnackbar(true);
    } catch (e) {}
  };

  return (
    <div
      id="contacts"
      style={
        x > 800
          ? {
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }
          : {}
      }
      className="main-subpage"
    >
      <div className="contact-form-titles">
        <h2 style={x > 800 ? { textAlign: "left" } : {}} className="main-title">
          {t("contactform_title")}
        </h2>
        <div
          style={x > 800 ? { textAlign: "left" } : {}}
          className="main-subtitle"
        >
          Email: info@flavysofts.com
          <br></br>
          Telegram: @FlavySupport
        </div>
      </div>
      <div className="contact-form">
        <div className="form-name-inputs">
          <div className="form-input-container">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("contactform_name")}
            ></input>
          </div>
          <div className="form-input-container">
            <input
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              placeholder={t("contactform_company")}
            ></input>
          </div>
        </div>
        <div className="form-input-container">
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("contactform_email")}
          ></input>
        </div>
        <div className="form-input-container">
          <input
            value={telegram}
            onChange={(e) => setTelegram(e.target.value)}
            placeholder="Telegram @"
          ></input>
        </div>
        <div className="form-input-container">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            placeholder={t("contactform_message")}
          ></textarea>
        </div>
        <button onClick={sendMessage} className="form-button">
          <p>{t("contact_button")}</p>
        </button>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
